import { InfoIcon } from "@phosphor-icons/react";
import PropTypes from "prop-types";
import { formatClassNames } from "../../../utils/common";
/**
 *
 * @returns
 */
const CountryChangeInfoMobile = ({ countryName, isFromOutsideDrawer }) => {
  return (
    <div
      className={formatClassNames(
        "mt-16 flex gap-4 rounded-8 bg-blue-100/10 p-10 text-12 font-400 text-blue-100",
        isFromOutsideDrawer && "mb-12 mt-8",
      )}
    >
      <InfoIcon size={16} className="flex-shrink-0" />
      <span>
        Sending gift to {countryName} Confirm & we will redirect you to FNP {countryName}
      </span>
    </div>
  );
};
CountryChangeInfoMobile.propTypes = {
  countryName: PropTypes.string.isRequired,
  isFromOutsideDrawer: PropTypes.bool,
};
export default CountryChangeInfoMobile;
